/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { FormTransformations } from "../../../types/ProductService/ProductService";

const abstractCaseTransformations: FormTransformations = {
  ibanFields: ["client.bankData.iban"],
};

export default abstractCaseTransformations;
